import { render, staticRenderFns } from "./planForPayment.vue?vue&type=template&id=15213742&scoped=true"
import script from "./planForPayment.vue?vue&type=script&lang=js"
export * from "./planForPayment.vue?vue&type=script&lang=js"
import style0 from "./planForPayment.vue?vue&type=style&index=0&id=15213742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15213742",
  null
  
)

export default component.exports